import {formatUrl} from 'url-lib';

import {fetchJSON} from 'js-utils/http';
import {pruneObject} from '@eb/destination-utils';

import {deepKeysToSnake, keysCamelToSnake} from 'js-utils/transformation';
import {
    CURRENT_FUTURE,
    QUALITY,
} from '../constants';

const searchUrl = '/api/v3/destination/search/';
const searchAutocompleteSuggestionsUrl = '/api/v3/destination/search/autocomplete/';

export const search = ({searchQuery}) => {
    const requestParameters = {
        'event_search': deepKeysToSnake(pruneObject({...searchQuery, 'page_size': 20})),
        'expand.destination_event': [
            'primary_venue',
            'image',
            'ticket_availability',
            'saves',
            'series',
            'my_collections',
        ],
    };

    return fetchJSON(
        searchUrl,
        {
            method: 'POST',
            body: JSON.stringify(requestParameters),
        },
    );
};

export const searchAutocompleteSuggestions = ({placeId, onlineEventsOnly, query}) => {
    let queryParams = {
        placeId,
        q: query,
        completionTypes: ['event', 'query'],
        'expand.destination_event': [
            'primary_venue',
            'image',
        ],
    };

    if (onlineEventsOnly) {
        queryParams.onlineEventsOnly = true;
    }

    queryParams = keysCamelToSnake(queryParams);
    return fetchJSON(formatUrl(searchAutocompleteSuggestionsUrl, queryParams));
};

export const searchSuggestionsForCity = ({placeId, onlineEventsOnly}) => fetchJSON(
    searchUrl,
    {
        method: 'POST',
        body: JSON.stringify({
            'event_search': {
                places: placeId ? [placeId] : [],
                'online_events_only': onlineEventsOnly,
                dates: CURRENT_FUTURE,
                sort: QUALITY,
                aggs: {
                    tags: {},
                },
            },
            'expand.destination_event': [
                'primary_venue',
                'image',
                'ticket_availability',
                'saves',
                'my_collections',
            ],
        }),
    },
);
